/*
================================================================ 
     Copyright (c) 2018-2020 Digitize Things Inc.           
           All rights reserved.                       
================================================================ 
*/

import React, { useState } from "react";
import classes from "../reports.module.css";
import Grid from "@mui/material/Grid";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Pagination from "@mui/material/Pagination";
import { Select, Tooltip } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import CloudDownload from "@mui/icons-material/CloudDownload";
import Payment from "@mui/icons-material/Payment";
import { withTranslation } from "react-i18next";
import currencyFormatter from "../../../../helper/currencyFormatter";
import { Link } from "react-router-dom";
import Button from "../../../../component/button";
import SubscriptionDialog from "../../subscriptionAdjustments/subscriptionDialog";
import ApprovalDialog from "../../subscriptionAdjustment/ApprovalDialog";
import { useEffect } from "react";
import BusApiCall from "../../../../helper/axios";
import constants from "../../../../helper/constants";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import IconButton from "@mui/material/IconButton";
// import EditIcon from '@mui/icons-material/Edit';
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import Typography from "@mui/material/Typography";
import Loader from "../../../../component/loader";
import { RefreshIcon } from "../../../../component/icons/icons";
import {
  AcceptIcon,
  EditIcon,
  ViewIconNew,
} from "../../../../component/icons/icons";
import Card from "@mui/material/Card";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Chip from "@mui/material/Chip";
import TableContainer from "@mui/material/TableContainer";
import Base64ViewerDialog from "../../../../component/fileViewer";
import { formatNumber } from "../../../../helper/numberFormatter";
import { formatDate } from "../../../../helper/dateFormatter";

const BillingAccount = (props) => {
  const t = props.t;
  const mainStyle = {
    maxWidth: "auto",
    // margin: 'auto',
    width: "-webkit-fill-available",
    padding: "auto",
    paddingTop: "0",
    paddingRight: "0",
    background: "transparent",
  };
  const [isApprovalForm, setApprovalForm] = useState(false);
  const [isSubscriptionDialog, setSubscriptionDialog] = useState(false);
  const [typeList, setTypeList] = useState([]);
  const [open, setOpen] = useState(false);
  const [history, setSubHistory] = useState([]);
  const [isEdit, setEdit] = useState(false);
  const [adjustment, setAdjustment] = useState({});
  const [loading, setLoading] = useState(false);
  const [taskForm, setTaskForm] = useState({});
  const [tabValue, setTabValue] = useState(0);
  const [paymentModuleActive, setPaymentModuleActive] = useState({});

  const handleClose = (val) => {
    setSubscriptionDialog(false);
    if (val) {
      if (val === "add") {
        props.setErrorMessage(t("ADJUSTMENT_CREATED_SUCCESFULLY"), true);
      } else {
        setEdit(false);
        setAdjustment({});
        props.setErrorMessage(t("ADJUSTMENT_UPDATED_SUCCESFULLY"), true);
      }
      props.getSubscriptionAdjustments(props.customerDetails.partyId);
    }
  };

  const handleApproval = (val) => {
    setApprovalForm(false);
    if (val) {
      if (val === "Approve") {
        props.setErrorMessage(t("ADJUSTMENT_APPROVED_SUCCESFULLY"), true);
      } else {
        //setAdjustment({});
        props.setErrorMessage(t("ADJUSTMENT_REJECTED_SUCCESFULLY"), true);
      }
      props.getSubscriptionAdjustments(props.customerDetails.partyId);
    }
  };

  const handleApprovalForm = (adjustmentId) => {
    setLoading(true);
    BusApiCall(
      "GET",
      `${constants.busV44UrlPublic}/subscriptionAdjustments/${adjustmentId}?operation=taskForms`,
      {},
    )
      .then((res) => {
        let data = res.data;
        setTaskForm(data);
        setApprovalForm(true);
        setLoading(false);
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          props.setErrorMessage(err.response.data.message, false);
        } else {
          props.setErrorMessage(this.props.t("DEFAULT_ERROR_MESSAGE"), false);
        }
        setLoading(false);
      });
  };

  useEffect(() => {
    props.onRef(setSubscriptionDialog);
    getAdjustmentTypes();
    var modules = JSON.parse(localStorage.getItem("modules"));
    // console.log('modules: ', modules ? modules : {})
    if (modules && modules.module_payment === "enabled") {
      setPaymentModuleActive(true);
    } else {
      setPaymentModuleActive(false);
    }
  }, []);

  const getAdjustmentTypes = () => {
    BusApiCall(
      "POST",
      `${constants.busInternalUrl}/passthru/GET_ADJUSTMENT_TYPES/endpoint`,
      {},
    )
      .then((res) => {
        setTypeList(res.data);
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          props.setErrorMessage(err.response.data.message, false);
        } else {
          props.setErrorMessage(props.t("DEFAULT_ERROR_MESSAGE"), false);
        }
      });
  };
  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <div style={mainStyle}>
      <div className={classes.root}>
        <>
          {/* {props.renderBillingView && props.data.latestInvoice && props.invoiceHistoryData && props.subData.subscriptionDetails ? */}
          <>
            <Grid
              container
              spacing={2}
              style={{ padding: "1rem 1rem 0rem 1rem" }}
            >
              <Grid
                item
                size={{
                  xs: 12,
                  md: 9,
                }}
              >
                {props.customerDetails && props.customerDetails.accountName && (
                  <h3 style={{ marginTop: 0 }}>
                    {/* {t("INVOICE_HISTORY")}:  */}
                    {props.customerDetails.accountName} (
                    {props.customerDetails.ban})
                  </h3>
                )}
              </Grid>
              <Grid item size={{ xs:12, md: 3 }} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                  onClick={props.getUpcomingInvoices}
                >
                  {t('UPCOMING_INVOICES')}
                </Button>
              </Grid>
              {/* <Grid item xs={3}>
                                {props && props.customerDetails &&
                                    <Button
                                        onClick={
                                            () => {
                                                setSubscriptionDialog(true)
                                            }
                                        } >
                                        {t('NEW_SUBSCRIPTION_ADJUSTMENT')}
                                    </Button>
                                }
                            </Grid> */}
            </Grid>
            {/* <Grid container spacing={1} > */}
            <Grid
              item
              style={{ paddingBottom: "1rem" }}
              size={{
                xs: 12,
              }}
            >
              <Box className={classes.tabUnderLine}>
                <Tabs
                  // indicatorColor="primary"
                  TabIndicatorProps={{
                    style: {
                      backgroundColor: props.themeColor, // Use dynamic color here
                    },
                  }}
                  // textColor="primary"
                  scrollButtons="auto"
                  onChange={handleChange}
                  value={tabValue}
                  className={classes.createPackageTabs}
                >
                  <Tab value={0} label={t("INVOICE_HISTORY")} />

                  {/* Commenting out Billing Adjustments for OOREDOO CUR4-4023 - will handle it later based on submodules */}
                  {/* {props.menuPaths.includes("/subscriptionAdjustments") &&
											<Tab value={1} label={t('SUBSCRIPTION_ADJUSTMENTS')} />
										} */}
                </Tabs>
              </Box>
            </Grid>
            {/* </Grid> */}

            {tabValue === 0 && (
              <>
                <div
                  style={{
                    paddingLeft: "1rem",
                    paddingRight: "1rem",
                    paddingBottom: "1rem",
                  }}
                >
                  <Grid
                    item
                    style={{ display: "none" }}
                    size={{
                      xs: 12,
                    }}
                  >
                    <h3 style={{ marginTop: "1rem", marginBottom: "1rem" }}>
                      {t("LATEST_INVOICE")}
                    </h3>
                  </Grid>
                  {!props.data.latestInvoice && (
                    <Box
                      className="roundCorners"
                      style={{
                        border: "1px solid lightgrey",
                        marginTop: "1rem",
                        padding: "1.5rem",
                        display: "none",
                      }}
                    >
                      <Grid container spacing={2} align="center">
                        <Grid
                          item
                          align="center"
                          size={{
                            xs: 12,
                          }}
                        >
                          {t("LATEST_INVOICE_NOT_FOUND")}
                        </Grid>
                      </Grid>
                    </Box>
                  )}
                  {props.data.latestInvoice && (
                    <Box
                      className="roundCorners"
                      style={{
                        border: "1px solid lightgrey",
                        marginTop: "1rem",
                        display: "none",
                      }}
                    >
                      <TableContainer>
                        <Table className={"newGlobalTable"}>
                          <TableHead>
                            {/* <TableRow>
												<TableCell colSpan={7}>
													<h3 style={{ marginTop: 0, marginBottom: 0 }}>{t("LATEST_INVOICE")}</h3>
												</TableCell>
											</TableRow> */}
                            {/* </TableHead> */}
                            {/* <TableBody> */}
                            <TableRow>
                              <TableCell>
                                <b>{t("ORDER_ID")}</b>
                              </TableCell>
                              <TableCell>
                                <b>{t("INVOICE_NO")}</b>
                              </TableCell>
                              <TableCell>
                                <b>{t("PAYMENT_MODE")}</b>
                              </TableCell>
                              <TableCell>
                                <b>{t("AMOUNT")}</b>
                              </TableCell>
                              <TableCell>
                                <b>{t("DATE")}</b>
                              </TableCell>
                              <TableCell colSpan={1}>
                                <b>{t("INVOICE_STATUS")}</b>
                              </TableCell>
                              <TableCell>
                                <b>{t("ACTIONS")}</b>
                              </TableCell>
                              {/* <TableCell>
												<Grid container spacing={0}>
													<Grid item xs={2}>
														<b>{t('ORDER_ID')}</b>
													</Grid>
													<Grid item xs={1}>
														<b>{t('INVOICE_NO')}</b>
													</Grid>
													<Grid item xs={2}>
														<b>{t('PAYMENT_MODE')}</b>
													</Grid>
													<Grid item xs={2}>
														<b>{t('AMOUNT')}</b>
													</Grid>
													<Grid item xs={2}>
														<b>{t('DATE')}</b>
													</Grid>
													<Grid item xs={2}>
														<b>{t('INVOICE_STATUS')}</b>
													</Grid>
													<Grid item xs={1}>
														<b> </b>
													</Grid>

												</Grid>
											</TableCell> */}
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            <TableRow>
                              <TableCell>
                                {props.data.latestInvoice.orderId}
                              </TableCell>
                              <TableCell>
                                {props.data.latestInvoice.invoiceId}
                              </TableCell>
                              <TableCell>
                                {props.data.latestInvoice.paidBy != null ? (
                                  <>
                                    {props.data.latestInvoice.paidBy}{" "}
                                    {props.data.latestInvoice.paidByNumber}
                                  </>
                                ) : (
                                  <>{t("INVOICED_TO_CUSTOMER")}</>
                                )}
                              </TableCell>
                              <TableCell>
                                {currencyFormatter(
                                  props.data.latestInvoice.totalInvoiceAmount,
                                )}
                              </TableCell>
                              <TableCell>
                                {formatDate(props.data.latestInvoice.invoiceDate)}
                              </TableCell>
                              <TableCell>
                                <Chip
                                  size="normal"
                                  className={
                                    props.data.latestInvoice.status === "Paid"
                                      ? "successChip" : 
                                       props.data.latestInvoice.status === "Unpaid"
                                        ? "errorChip"
                                      : "inProgressChip"
                                  }
                                  label={props.data.latestInvoice.status}
                                />
                                {/* {props.data.latestInvoice.status} */}
                              </TableCell>
                              <TableCell style={{}}>
                                <Tooltip title={t("VIEW")}>
                                  <span style={{ marginRight: 10 }}>
                                    <Button
                                      className={
                                        "buttonSecondary" +
                                        " " +
                                        "iconButtonSecondary"
                                      }
                                      onClick={() => {
                                        props.downloadInvoicePdf(
                                          props.data.latestInvoice.orderId,
                                          props.data.latestInvoice.invoiceId,
                                          "view",
                                        );
                                      }}
                                    >
                                      <ViewIconNew />
                                    </Button>
                                  </span>
                                </Tooltip>
                                {props.data.latestInvoice.status === "Unpaid" &&
                                  paymentModuleActive && (
                                    <Tooltip title={t("PAY_INVOICE")}>
                                      <Button
                                        className={"smallButton"}
                                        onClick={() => {
                                          props.initiateInvoicePayment(
                                            props.data.latestInvoice.orderId,
                                            props.data.latestInvoice.invoiceId,
                                          );
                                        }}
                                      >
                                        {t("PAY_INVOICE")}
                                      </Button>
                                      {/* <Payment
																	style={{ marginLeft: 10 }}
																	onClick={() => {
																		props.initiateInvoicePayment(props.data.latestInvoice.orderId, props.data.latestInvoice.invoiceId);
																	}}
																/> */}
                                    </Tooltip>
                                  )}
                                <Tooltip title={t("DOWNLOAD")}>
                                  <Button
                                    className={
                                      "buttonSecondary" +
                                      " " +
                                      "iconButtonSecondary"
                                    }
                                    onClick={() => {
                                      props.downloadInvoicePdf(
                                        props.data.latestInvoice.orderId,
                                        props.data.latestInvoice.invoiceId,
                                      );
                                    }}
                                  >
                                    <svg
                                      width="12"
                                      height="12"
                                      viewBox="0 0 12 12"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M6 1C6.27614 1 6.5 1.22386 6.5 1.5V7.29289L8.64645 5.14645C8.84171 4.95118 9.15829 4.95118 9.35355 5.14645C9.54882 5.34171 9.54882 5.65829 9.35355 5.85355L6.35355 8.85355C6.15829 9.04882 5.84171 9.04882 5.64645 8.85355L2.64645 5.85355C2.45118 5.65829 2.45118 5.34171 2.64645 5.14645C2.84171 4.95118 3.15829 4.95118 3.35355 5.14645L5.5 7.29289V1.5C5.5 1.22386 5.72386 1 6 1ZM1 10.5C1 10.2239 1.22386 10 1.5 10H10.5C10.7761 10 11 10.2239 11 10.5C11 10.7761 10.7761 11 10.5 11H1.5C1.22386 11 1 10.7761 1 10.5Z"
                                        fill="currentColor"
                                      />
                                    </svg>
                                  </Button>
                                  {/* <CloudDownload
																style={{ marginLeft: 10 }}
																onClick={() => {
																	props.downloadInvoicePdf(props.data.latestInvoice.orderId, props.data.latestInvoice.invoiceId);
																}}
															/> */}
                                </Tooltip>
                              </TableCell>
                              {/* <TableCell>
													<Grid container spacing={0}>
														<Grid item xs={2}>
															{props.data.latestInvoice.orderId}
														</Grid>
														<Grid item xs={1}>
															{props.data.latestInvoice.invoiceId}
														</Grid>
														<Grid item xs={3}>
															{props.data.latestInvoice.paidBy != null ?
																<>
																	{props.data.latestInvoice.paidBy} {props.data.latestInvoice.paidByNumber}
																</>
																:
																<>
																	{t('INVOICED_TO_CUSTOMER')}
																</>
															}
														</Grid>
														<Grid item xs={2}>
															{currencyFormatter(props.data.latestInvoice.totalInvoiceAmount)}
														</Grid>
														<Grid item xs={2}>
															{props.data.latestInvoice.invoiceDate}
														</Grid>
														<Grid item xs={1}>
															{props.data.latestInvoice.status}
														</Grid>
														<Grid item xs={1}>
															<Tooltip title={t('DOWNLOAD')}>
																<CloudDownload style={{ marginLeft: 10 }} onClick={() => { props.downloadInvoicePdf(props.data.latestInvoice.orderId, props.data.latestInvoice.invoiceId) }} />
															</Tooltip>
															{props.data.latestInvoice.status === 'Unpaid' &&
																<Tooltip title={t('PAY_INVOICE')}>
																	<Payment style={{ marginLeft: 10 }} onClick={() => { props.initiateInvoicePayment(props.data.latestInvoice.orderId, props.data.latestInvoice.invoiceId) }} />
																</Tooltip>
															}
														</Grid>

													</Grid>
												</TableCell> */}
                            </TableRow>

                            {props.searchingBillingData && (
                              <TableRow>
                                <TableCell colSpan={7} align="center">
                                  {/* <Grid container spacing={0}>
														<Grid item xs={12} align="center"> */}
                                  {t("SEARCHING")}
                                  {/* </Grid>
													</Grid> */}
                                </TableCell>
                              </TableRow>
                            )}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Box>
                  )}
                  {/* </Paper> */}

                  {/* <Paper className={'tablePaper'} style={{ marginTop: 50 }}> */}
                  <Grid
                    item
                    size={{
                      xs: 12,
                    }}
                  >
                    <h3 style={{ marginBottom: "1rem" }}>
                      {t("INVOICE_HISTORY")}
                    </h3>
                  </Grid>
                  {(!props.invoiceHistoryData ||
                    props.invoiceHistoryData.length === 0) &&
                    !props.searchingBillingData && (
                      <Box
                        className="roundCorners"
                        style={{
                          border: "1px solid lightgrey",
                          marginTop: "1rem",
                          padding: "1.5rem",
                        }}
                      >
                        <Grid container spacing={2} align="center">
                          <Grid
                            item
                            size={{
                              xs: 12,
                            }}
                          >
                            {t("INVOICE_HISTORY_NOT_FOUND")}
                          </Grid>
                        </Grid>
                      </Box>
                    )}
                  {
                    !(
                      (!props.invoiceHistoryData ||
                        props.invoiceHistoryData.length === 0) &&
                      !props.searchingBillingData
                    ) && (
                      // <Box className="roundCorners" style={{ border: "1px solid lightgrey", marginTop: "1rem" }}>
                      <Card
                        variant="outlined"
                        style={{ borderRadius: "8px", marginTop: "1rem" }}
                      >
                        <TableContainer>
                          <Table className={"newGlobalTable"}>
                            <TableHead>
                              {/* <TableRow>
												<TableCell colSpan={7}>
													<h3 style={{ marginTop: 0, marginBottom: 0 }}>{t("INVOICE_HISTORY")}</h3>
												</TableCell>
											</TableRow> */}
                              {/* </TableHead>
										<TableBody> */}
                              <TableRow>
                                {/* <TableCell>
                                  <b>{t("ORDER_ID")}</b>
                                </TableCell> */}
                                <TableCell>
                                  {" "}
                                  <b>{t("INVOICE_NO")}</b>
                                  {/* {props.sortBy === "invoiceId" ? (
														<span className="material-icons">{props.sortOrder === "DESC" ? "expand_less" : "expand_more"}</span>
													) : (
														<span className="material-icons sorting-indicator-icon">unfold_more</span>
													)} */}
                                </TableCell>
                                <TableCell>
                                  <b>{t("PAYMENT_MODE")}</b>
                                </TableCell>
                                <TableCell>
                                  {" "}
                                  <b>{t("AMOUNT")}</b>
                                </TableCell>
                                <TableCell>
                                  {" "}
                                  <b>{t("DATE")}</b>
                                </TableCell>
                                <TableCell colSpan={1}>
                                  <b>{t("INVOICE_STATUS")}</b>
                                </TableCell>
                                <TableCell>
                                  <b>{t("ACTIONS")}</b>
                                </TableCell>
                                {/* <TableCell>
												<Grid container spacing={0}>
													<Grid item xs={2} style={{ marginTop: 10 }}>
														<b>{t('ORDER_ID')}</b>
													</Grid>
													<Grid item xs={1} className="global-custom-sorting-header" onClick={(e) => { props.updateInvoiceSorting("invoiceId") }}>
														<b>{t('INVOICE_NO')}</b>
														{props.sortBy === 'invoiceId' ?
															<span className="material-icons">
																{props.sortOrder === 'DESC' ? 'expand_less' : 'expand_more'}
															</span>
															:
															<span className="material-icons sorting-indicator-icon">
																unfold_more
															</span>
														}
													</Grid>
													<Grid item xs={3} style={{ marginTop: 10 }}>
														<b>{t('PAYMENT_MODE')}</b>
													</Grid>
													<Grid item xs={2} style={{ marginTop: 10 }}>
														<b>{t('AMOUNT')}</b>
													</Grid>
													<Grid item xs={2} style={{ marginTop: 10 }}>
														<b>{t('DATE')}</b>
													</Grid>
													<Grid item xs={1} style={{ marginTop: 10 }}>
														<b>{t('INVOICE_STATUS')}</b>
													</Grid>
													<Grid item xs={1}>
														<b> </b>
													</Grid>

												</Grid>
											</TableCell> */}
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {props.invoiceHistoryData &&
                                props.invoiceHistoryData.map((row, index) => (
                                  <TableRow key={index}>
                                    {/* <TableCell>{row.orderId}</TableCell> */}
                                    <TableCell>{row.invoiceId}</TableCell>
                                    <TableCell>
                                      {row.paidBy != null ? (
                                        <>
                                          {row.paidBy} {row.paidByNumber}
                                        </>
                                      ) : (
                                        <>{t("INVOICED_TO_CUSTOMER")}</>
                                      )}
                                    </TableCell>
                                    <TableCell>
                                      {currencyFormatter(
                                        row.totalInvoiceAmount,
                                      )}
                                    </TableCell>
                                    <TableCell>{formatDate(row.invoiceDate)}</TableCell>
                                    <TableCell>
                                      <Chip
                                        size="normal"
                                        className={
                                          row.status === "Paid"
                                            ? "successChip"
                                            : row.status === "Unpaid"
                                              ? "errorChip"
                                              : "inProgressChip"
                                        }
                                        label={row.status}
                                      />
                                      {/* {row.status} */}
                                    </TableCell>
                                    <TableCell style={{ whiteSpace: "nowrap" }}>
                                      <Tooltip title={t("VIEW")}>
                                        <span style={{ marginRight: 10 }}>
                                          <Button
                                            className={
                                              "buttonSecondary" +
                                              " " +
                                              "iconButtonSecondary"
                                            }
                                            onClick={() => {
                                              props.downloadInvoicePdf(
                                                row.orderId,
                                                row.invoiceId,
                                                "view",
                                              );
                                            }}
                                          >
                                            <ViewIconNew />
                                          </Button>
                                        </span>
                                      </Tooltip>
                                      {row.status === "Unpaid" &&
                                        paymentModuleActive && (
                                          <Tooltip title={t("PAY_INVOICE")}>
                                            <span>
                                              <Button
                                                className={"smallButton"}
                                                style={{ whiteSpace: "nowrap" }}
                                                onClick={() => {
                                                  props.initiateInvoicePayment(
                                                    row.orderId,
                                                    row.invoiceId,
                                                  );
                                                }}
                                              >
                                                {t("PAY_INVOICE")}
                                              </Button>
                                            </span>
                                            {/* <Payment
																		style={{ marginLeft: 10 }}
																		onClick={() => {
																			props.initiateInvoicePayment(row.orderId, row.invoiceId);
																		}}
																	/> */}
                                          </Tooltip>
                                        )}
                                      <Tooltip title={t("DOWNLOAD")}>
                                        <span>
                                          <Button
                                            className={
                                              "buttonSecondary" +
                                              " " +
                                              "iconButtonSecondary"
                                            }
                                            onClick={() => {
                                              props.downloadInvoicePdf(
                                                row.orderId,
                                                row.invoiceId,
                                              );
                                            }}
                                          >
                                            <svg
                                              width="12"
                                              height="12"
                                              viewBox="0 0 12 12"
                                              fill="none"
                                              xmlns="http://www.w3.org/2000/svg"
                                            >
                                              <path
                                                fillRule="evenodd"
                                                clipRule="evenodd"
                                                d="M6 1C6.27614 1 6.5 1.22386 6.5 1.5V7.29289L8.64645 5.14645C8.84171 4.95118 9.15829 4.95118 9.35355 5.14645C9.54882 5.34171 9.54882 5.65829 9.35355 5.85355L6.35355 8.85355C6.15829 9.04882 5.84171 9.04882 5.64645 8.85355L2.64645 5.85355C2.45118 5.65829 2.45118 5.34171 2.64645 5.14645C2.84171 4.95118 3.15829 4.95118 3.35355 5.14645L5.5 7.29289V1.5C5.5 1.22386 5.72386 1 6 1ZM1 10.5C1 10.2239 1.22386 10 1.5 10H10.5C10.7761 10 11 10.2239 11 10.5C11 10.7761 10.7761 11 10.5 11H1.5C1.22386 11 1 10.7761 1 10.5Z"
                                                fill="currentColor"
                                              />
                                            </svg>
                                          </Button>
                                        </span>

                                        {/* <CloudDownload
																	style={{ marginLeft: 10 }}
																	onClick={() => {
																		props.downloadInvoicePdf(row.orderId, row.invoiceId);
																	}}
																/> */}
                                      </Tooltip>
                                    </TableCell>
                                    {/* <TableCell>
															<Grid container spacing={0}>
																<Grid item xs={2}>
																	{row.orderId}
																</Grid>
																<Grid item xs={1}>
																	{row.invoiceId}
																</Grid>
																<Grid item xs={3}>
																	{row.paidBy != null ?
																		<>
																			{row.paidBy} {row.paidByNumber}
																		</>
																		:
																		<>
																			{t('INVOICED_TO_CUSTOMER')}
																		</>
																	}
																</Grid>
																<Grid item xs={2}>
																	{currencyFormatter(row.totalInvoiceAmount)}
																</Grid>
																<Grid item xs={2}>
																	{row.invoiceDate}
																</Grid>
																<Grid item xs={1}>
																	{row.status}
																</Grid>
																<Grid item xs={1}>
																	<Tooltip title={t('DOWNLOAD')}>
																		<CloudDownload style={{ marginLeft: 10 }} onClick={() => { props.downloadInvoicePdf(row.orderId, row.invoiceId) }} />
																	</Tooltip>
																	{row.status === 'Unpaid' &&
																		<Tooltip title={t('PAY_INVOICE')} >
																			<Payment style={{ marginLeft: 10 }} onClick={() => { props.initiateInvoicePayment(row.orderId, row.invoiceId) }} />
																		</Tooltip>
																	}
																</Grid>

															</Grid>
														</TableCell> */}
                                  </TableRow>
                                ))}

                              {props.searchingBillingData && (
                                <TableRow>
                                  <TableCell colSpan={7} align="center">
                                    {t("SEARCHING")}
                                  </TableCell>
                                </TableRow>
                              )}
                            </TableBody>
                          </Table>
                        </TableContainer>
                        {props.totalInvoiceCount > 0 && (
                          <div
                            className="global-custom-pagination"
                            style={{ background: "rgba(196, 196, 196, 0.2)" }}
                          >
                            <label style={{ float: "left", padding: "5px" }}>
                              {t("TOTAL_RECORDS")}: {formatNumber(props.totalInvoiceCount)}
                            </label>
                            <label>
                              {/* Rows per page select */}
                              {t("ROWS_PER_PAGE")}:
                              <Select
                                value={props.invoiceHistoryPerPage}
                                onChange={props.updateInvoiceHistoryPerPageRows}
                              >
                                <MenuItem
                                  value={10}
                                  classes={{ root: "treeRowPerPageItem" }}
                                >
                                  10
                                </MenuItem>
                                <MenuItem
                                  value={50}
                                  classes={{ root: "treeRowPerPageItem" }}
                                >
                                  50
                                </MenuItem>
                                <MenuItem
                                  value={100}
                                  classes={{ root: "treeRowPerPageItem" }}
                                >
                                  100
                                </MenuItem>
                              </Select>
                            </label>
                            {/* Pagination component */}
                            <Pagination
                              page={props.invoiceHistoryPage}
                              count={Math.ceil(
                                props.totalInvoiceCount /
                                props.invoiceHistoryPerPage,
                              )}
                              onChange={props.onInvoiceHistoryPageChange}
                              showFirstButton
                              showLastButton
                            />
                          </div>
                        )}
                      </Card>
                    )
                    // </Box>
                  }
                  {/* </Paper> */}
                </div>
              </>
            )}

            {tabValue === 1 && (
              <>
                {/* <Paper className={'tablePaper'} style={{ marginTop: 50 }}> */}
                <div
                  style={{
                    paddingLeft: ".5rem",
                    paddingRight: "1rem",
                    paddingBottom: "1rem",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginTop: "1rem",
                      marginBottom: "1rem",
                    }}
                  >
                    <b style={{ fontSize: "initial" }}>
                      {t("SUBSCRIPTION_ADJUSTMENT")}
                    </b>
                    {/* <h3 style={{ marginTop: 0, marginBottom: 0 }}>{t('SUBSCRIPTION_ADJUSTMENT')}</h3> */}
                    <div>
                      <Button
                        style={{ marginRight: "15px" }}
                        onClick={() => {
                          setSubscriptionDialog(true);
                        }}
                      >
                        <span
                          style={{
                            marginRight: ".25rem",
                            verticalAlign: "middle",
                          }}
                        >
                          <svg
                            width="14"
                            height="14"
                            viewBox="0 0 12 12"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M6 2C6.27614 2 6.5 2.22386 6.5 2.5V5.5H9.5C9.77614 5.5 10 5.72386 10 6C10 6.27614 9.77614 6.5 9.5 6.5H6.5V9.5C6.5 9.77614 6.27614 10 6 10C5.72386 10 5.5 9.77614 5.5 9.5V6.5H2.5C2.22386 6.5 2 6.27614 2 6C2 5.72386 2.22386 5.5 2.5 5.5H5.5V2.5C5.5 2.22386 5.72386 2 6 2Z"
                              fill="currentColor"
                            />
                          </svg>
                        </span>
                        {t("NEW_SUBSCRIPTION_ADJUSTMENT")}
                      </Button>
                      <Button
                        onClick={() => {
                          props.getSubscriptionAdjustments(
                            props.customerDetails.partyId,
                          );
                        }}
                        className={
                          "buttonSecondary" + " " + "iconButtonSecondary"
                        }
                      >
                        <span style={{ verticalAlign: "middle" }}>
                          <svg
                            width="12"
                            height="12"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M11.7716 4.22893C9.68876 2.14613 6.31189 2.14613 4.22909 4.22893C3.49043 4.96759 3.01458 5.86721 2.79969 6.81434C2.71822 7.17341 2.36109 7.39844 2.00203 7.31697C1.64297 7.2355 1.41793 6.87838 1.4994 6.51932C1.76833 5.33407 2.36458 4.20782 3.28628 3.28612C5.88978 0.682622 10.1109 0.682622 12.7144 3.28612C13.2464 3.81811 13.6672 4.26356 14.0003 4.63589V2.66683C14.0003 2.29864 14.2988 2.00016 14.667 2.00016C15.0352 2.00016 15.3337 2.29864 15.3337 2.66683V6.66683C15.3337 7.03502 15.0352 7.3335 14.667 7.3335H10.667C10.2988 7.3335 10.0003 7.03502 10.0003 6.66683C10.0003 6.29864 10.2988 6.00016 10.667 6.00016H13.4175C13.0761 5.58887 12.5571 5.01451 11.7716 4.22893ZM13.9986 8.68335C14.3577 8.76482 14.5827 9.12194 14.5012 9.48101C14.2323 10.6663 13.6361 11.7925 12.7144 12.7142C10.1109 15.3177 5.88978 15.3177 3.28628 12.7142C2.75429 12.1822 2.33349 11.7368 2.00033 11.3644V13.3335C2.00033 13.7017 1.70185 14.0002 1.33366 14.0002C0.965469 14.0002 0.666992 13.7017 0.666992 13.3335V9.3335C0.666992 8.96531 0.965469 8.66683 1.33366 8.66683H5.33366C5.70185 8.66683 6.00033 8.96531 6.00033 9.3335C6.00033 9.70169 5.70185 10.0002 5.33366 10.0002H2.58319C2.9245 10.4115 3.44351 10.9858 4.22909 11.7714C6.31189 13.8542 9.68876 13.8542 11.7716 11.7714C12.5102 11.0327 12.9861 10.1331 13.201 9.18598C13.2824 8.82692 13.6396 8.60188 13.9986 8.68335Z"
                              fill="currentColor"
                            />
                          </svg>
                        </span>
                        {/* {t("REFRESH")} */}
                      </Button>
                    </div>
                  </div>
                  {!props.showLoading &&
                    props.subscriptionAdjustments.length === 0 && (
                      <Box
                        className="roundCorners"
                        style={{
                          border: "1px solid lightgrey",
                          marginTop: "1rem",
                          padding: "1.5rem",
                        }}
                      >
                        <Grid
                          container
                          spacing={2}
                          align="center"
                          size={{
                            xs: 12,
                          }}
                        >
                          <Grid
                            item
                            size={{
                              xs: 12,
                            }}
                          >
                            {props.t("NO_ADJUSTMENT_FOUND")}
                          </Grid>
                        </Grid>
                      </Box>
                    )}
                  {props.showLoading &&
                    props.subscriptionAdjustments.length > 0 && (
                      <Box
                        className="roundCorners"
                        style={{
                          border: "1px solid lightgrey",
                          marginTop: "1rem",
                        }}
                      >
                        <TableContainer>
                          <Table className={"newGlobalTable"}>
                            <TableHead>
                              {/* <TableRow>
												<TableCell colSpan={6}>
													<div style={{display: 'flex', justifyContent: 'space-between'}}>
													<b style={{ fontSize: "initial" }}>{t("SUBSCRIPTION_ADJUSTMENT")}</b>
													<div
														onClick={() => {
															props.getSubscriptionAdjustments(props.customerDetails.partyId);
														}}
														style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
														className="tertiaryButton"
													>
														<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
															<path
																fillRule="evenodd"
																clipRule="evenodd"
																d="M11.7716 4.22893C9.68876 2.14613 6.31189 2.14613 4.22909 4.22893C3.49043 4.96759 3.01458 5.86721 2.79969 6.81434C2.71822 7.17341 2.36109 7.39844 2.00203 7.31697C1.64297 7.2355 1.41793 6.87838 1.4994 6.51932C1.76833 5.33407 2.36458 4.20782 3.28628 3.28612C5.88978 0.682622 10.1109 0.682622 12.7144 3.28612C13.2464 3.81811 13.6672 4.26356 14.0003 4.63589V2.66683C14.0003 2.29864 14.2988 2.00016 14.667 2.00016C15.0352 2.00016 15.3337 2.29864 15.3337 2.66683V6.66683C15.3337 7.03502 15.0352 7.3335 14.667 7.3335H10.667C10.2988 7.3335 10.0003 7.03502 10.0003 6.66683C10.0003 6.29864 10.2988 6.00016 10.667 6.00016H13.4175C13.0761 5.58887 12.5571 5.01451 11.7716 4.22893ZM13.9986 8.68335C14.3577 8.76482 14.5827 9.12194 14.5012 9.48101C14.2323 10.6663 13.6361 11.7925 12.7144 12.7142C10.1109 15.3177 5.88978 15.3177 3.28628 12.7142C2.75429 12.1822 2.33349 11.7368 2.00033 11.3644V13.3335C2.00033 13.7017 1.70185 14.0002 1.33366 14.0002C0.965469 14.0002 0.666992 13.7017 0.666992 13.3335V9.3335C0.666992 8.96531 0.965469 8.66683 1.33366 8.66683H5.33366C5.70185 8.66683 6.00033 8.96531 6.00033 9.3335C6.00033 9.70169 5.70185 10.0002 5.33366 10.0002H2.58319C2.9245 10.4115 3.44351 10.9858 4.22909 11.7714C6.31189 13.8542 9.68876 13.8542 11.7716 11.7714C12.5102 11.0327 12.9861 10.1331 13.201 9.18598C13.2824 8.82692 13.6396 8.60188 13.9986 8.68335Z"
																fill="currentColor"
															/>
														</svg>
														<span style={{ marginLeft: "6px" }}>{t("REFRESH")}</span>
													</div>
													</div>
												</TableCell>
											</TableRow> */}
                              {/* </TableHead>
										<TableBody> */}
                              <TableRow>
                                <TableCell>
                                  <b>{t("SUB_ADJUSTMENT_ID")}</b>
                                  {props.sortBy === "subAdjustmentId" ? (
                                    <span className="material-icons">
                                      {props.sortOrder === "DESC"
                                        ? "expand_less"
                                        : "expand_more"}
                                    </span>
                                  ) : (
                                    <span className="material-icons sorting-indicator-icon">
                                      unfold_more
                                    </span>
                                  )}
                                </TableCell>
                                <TableCell>
                                  <b>{t("NAME")}</b>
                                </TableCell>
                                <TableCell>
                                  <b>{t("ADJUSTMENT_VALUE")}</b>
                                </TableCell>
                                <TableCell>
                                  <b>{t("ADJUSTMENT_TYPE")}</b>
                                </TableCell>
                                <TableCell colSpan={1}>
                                  <b>{t("STATUS")}</b>
                                </TableCell>
                                <TableCell>
                                  <b>{t("ACTIONS")}</b>
                                </TableCell>
                                {/* <TableCell>
												<Grid container spacing={0}>
													<Grid item xs={2} className="global-custom-sorting-header" onClick={(e) => { props.updateSorting("subAdjustmentId") }}>
														<b>{t('SUB_ADJUSTMENT_ID')}</b>
														{props.sortBy === 'subAdjustmentId' ?
															<span className="material-icons">
																{props.sortOrder === 'DESC' ? 'expand_less' : 'expand_more'}
															</span>
															:
															<span className="material-icons sorting-indicator-icon">
																unfold_more
															</span>
														}
													</Grid>
													<Grid item xs={2} style={{ marginTop: 10 }}>
														<b>{t('NAME')}</b>
													</Grid>
													<Grid item xs={2} style={{ marginTop: 10 }}>
														<b>{t('ADJUSTMENT_VALUE')}</b>
													</Grid>
													<Grid item xs={3} style={{ marginTop: 10 }}>
														<b>{t('ADJUSTMENT_TYPE')}</b>
													</Grid>
													<Grid item xs={2} style={{ marginTop: 10 }}>
														<b>{t('STATUS')}</b>
													</Grid>
													<Grid item xs={1} style={{ marginTop: 10 }}>

													</Grid>
												</Grid>
											</TableCell> */}
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {props.subscriptionAdjustments &&
                                props.subscriptionAdjustments.map(
                                  (row, index) => (
                                    <React.Fragment key={index}>
                                      <TableRow>
                                        <TableCell>
                                          <IconButton
                                            aria-label="expand row"
                                            size="small"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              setSubHistory(row.history);
                                              props.toggleAdjustmentInfo(row);
                                            }}
                                          >
                                            {row.open ? (
                                              <KeyboardArrowUpIcon />
                                            ) : (
                                              <KeyboardArrowDownIcon />
                                            )}
                                          </IconButton>
                                          {row.adjustmentId}
                                        </TableCell>
                                        <TableCell>{row.name}</TableCell>
                                        <TableCell>
                                          {row.value ? row.value.amount : null}
                                        </TableCell>
                                        <TableCell>{row.type}</TableCell>
                                        <TableCell>
                                          <Chip
                                            size="normal"
                                            className={
                                              row.status === "Paid"
                                                ? "successChip"
                                                : row.status === "Unpaid"
                                                  ? "errorChip"
                                                  : "inProgressChip"
                                            }
                                            label={row.status}
                                          />
                                          {/* {row.status} */}
                                        </TableCell>
                                        <TableCell>
                                          {row.status &&
                                            row.status == "PENDING_APPROVAL" ? (
                                            <Tooltip
                                              title={props.t(
                                                "UPDATE_ADJUSTMENT",
                                              )}
                                            >
                                              <IconButton
                                                style={{ marginRight: "4px" }}
                                                aria-label={props.t(
                                                  "UPDATE_ADJUSTMENT",
                                                )}
                                                onClick={() => {
                                                  setAdjustment(row);
                                                  setSubscriptionDialog(true);
                                                  setEdit(true);
                                                }}
                                              >
                                                <EditIcon
                                                  className={
                                                    classes.tableActionIcons
                                                  }
                                                />
                                              </IconButton>
                                            </Tooltip>
                                          ) : null}
                                          {row.status &&
                                            row.status == "PENDING_APPROVAL" &&
                                            props.userRoles.includes(
                                              "ADJUSTMENT_APPROVER",
                                            ) ? (
                                            <Tooltip
                                              title={props.t(
                                                "APPROVE_ADJUSTMENT",
                                              )}
                                            >
                                              <IconButton
                                                aria-label={props.t(
                                                  "APPROVE_ADJUSTMENT",
                                                )}
                                                onClick={() => {
                                                  setAdjustment(row);
                                                  handleApprovalForm(
                                                    row.adjustmentId,
                                                  );
                                                }}
                                              >
                                                <AcceptIcon />
                                              </IconButton>
                                            </Tooltip>
                                          ) : null}
                                        </TableCell>
                                        {/* <TableCell >
																<Grid container spacing={1} >
																	<Grid item xs={2} className={classes.tableGrid} style={{ display: "flex", alignItems: "flex-start" }}>
																		<IconButton aria-label="expand row" size="small" onClick={(e) => {
																			e.stopPropagation();
																			setSubHistory(row.history);
																			props.toggleAdjustmentInfo(row)
																		}}>
																			{row.open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
																		</IconButton>
																		{row.adjustmentId}
																	</Grid>
																	<Grid item xs={2} className={classes.tableGrid}>
																		{row.name}
																	</Grid>
																	<Grid item xs={2} className={classes.tableGrid}>{row.value ? row.value.amount : null}</Grid>
																	<Grid item xs={3} className={classes.tableGrid}>
																		{row.type}
																	</Grid>
																	<Grid item xs={1} className={classes.tableGrid}>
																		{row.status}
																	</Grid>
																	<Grid item align={"right"} className={classes.tableGrid} style={{ flexGrow: "1" }}>
																		{row.status && row.status == 'PENDING_APPROVAL' ?
																			<Tooltip title={props.t('UPDATE_ADJUSTMENT')}>
																				<IconButton style={{ marginRight: "4px" }} aria-label={props.t('UPDATE_ADJUSTMENT')}
																					onClick={() => {
																						setAdjustment(row);
																						setSubscriptionDialog(true);
																						setEdit(true)
																					}}>
																					<EditIcon className={classes.tableActionIcons} />
																				</IconButton>
																			</Tooltip>
																			:
																			null
																		}
																		{row.status && row.status == 'PENDING_APPROVAL' && props.userRoles.includes('ADJUSTMENT_APPROVER') ?
																			<Tooltip title={props.t('APPROVE_ADJUSTMENT')}>
																				<IconButton aria-label={props.t('APPROVE_ADJUSTMENT')}
																					onClick={() => {
																						setAdjustment(row);
																						handleApprovalForm(row.adjustmentId);
																					}}>
																					<AcceptIcon />
																				</IconButton>
																			</Tooltip>
																			:
																			null
																		}
																	</Grid>

																</Grid>
															</TableCell> */}
                                      </TableRow>
                                      {row.open && (
                                        <TableRow>
                                          <TableCell
                                            style={{
                                              paddingBottom: 0,
                                              paddingTop: 0,
                                            }}
                                            colSpan={6}
                                          >
                                            <Collapse
                                              in={row.open}
                                              timeout="auto"
                                              unmountOnExit
                                            >
                                              <Box margin={1}>
                                                <Typography
                                                  gutterBottom
                                                  component="div"
                                                >
                                                  <b>
                                                    {" "}
                                                    {t(
                                                      "SUBSCRIPTION_ADJUSTMENT_LIFE_CYCLE",
                                                    )}
                                                  </b>
                                                </Typography>
                                                <TableContainer>
                                                  <Table size="small">
                                                    <TableHead>
                                                      <TableRow className="global-custom-sorting-header">
                                                        <TableCell>
                                                          {t("STATUS")}
                                                        </TableCell>
                                                        <TableCell>
                                                          {t("UPDATED_BY")}
                                                        </TableCell>
                                                      </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                      {history &&
                                                        history.map(
                                                          (historyRow) => (
                                                            <TableRow
                                                              key={
                                                                historyRow.status
                                                              }
                                                              className="global-custom-sorting-header"
                                                            >
                                                              <TableCell
                                                                component="th"
                                                                scope="row"
                                                              >
                                                                {
                                                                  historyRow.status
                                                                }
                                                              </TableCell>
                                                              <TableCell>
                                                                {
                                                                  historyRow.updatedBy
                                                                }
                                                              </TableCell>
                                                            </TableRow>
                                                          ),
                                                        )}
                                                    </TableBody>
                                                  </Table>
                                                </TableContainer>
                                              </Box>
                                            </Collapse>
                                          </TableCell>
                                        </TableRow>
                                      )}
                                    </React.Fragment>
                                  ),
                                )}
                            </TableBody>
                          </Table>
                        </TableContainer>
                        {props.totalOrderCount > 0 && (
                          <div
                            className="global-custom-pagination"
                            style={{ background: "rgba(196, 196, 196, 0.2)" }}
                          >
                            <label style={{ float: "left", padding: "5px" }}>
                              {props.t("TOTAL_RECORDS")}:{" "}
                              {props.totalOrderCount}
                            </label>
                            <label>
                              {/* Rows per page select */}
                              {props.t("ROWS_PER_PAGE")}:
                              <Select
                                value={props.subscriptionRowsPerPage}
                                onChange={
                                  props.handleSubscriptionChangeRowsPerPage
                                }
                              >
                                <MenuItem value={10}>10</MenuItem>
                                <MenuItem value={50}>50</MenuItem>
                                <MenuItem value={100}>100</MenuItem>
                              </Select>
                            </label>
                            {/* Pagination component */}
                            <Pagination
                              count={Math.ceil(
                                props.totalOrderCount /
                                props.subscriptionRowsPerPage,
                              )}
                              onChange={props.handleSubscriptionChangePage}
                              page={props.subscriptionPage}
                              showFirstButton
                              showLastButton
                            />
                          </div>
                        )}
                        {/* </Paper> */}
                      </Box>
                    )}
                </div>
              </>
            )}
          </>
          {isSubscriptionDialog && (
            <SubscriptionDialog
              isOpen={isSubscriptionDialog}
              close={handleClose}
              isEdit={isEdit}
              adjustment={adjustment}
              typeList={typeList}
              getAdjustmentTypes={getAdjustmentTypes}
              customerDetails={props.customerDetails}
            />
          )}
          {isApprovalForm && (
            <ApprovalDialog
              isOpen={isApprovalForm}
              close={handleApproval}
              taskForm={taskForm}
              //getSubscription={this.getSubscriptionAdjustment}
              adjustment={adjustment}
            />
          )}
          <Loader loading={loading} />
          {/* :
                            <div>
                                <h3 align="center" style={{ marginTop: 0 }}>Please wait, data is being processed...</h3>
                            </div>
                        } */}
        </>
      </div>
    </div>
  );
};

export default withTranslation("translations")(BillingAccount);
